import React from "react";
import { Platform } from "react-native";

import OnboardingButton from "./OnboardingButton";
import useSharePress from "../hooks/useSharePress";
import { t } from "@/localization";

const ShareEventButton = ({
  style,
  title,
  url,
  text = t("Share"),
  ...props
}) => {
  // const [socialIconsVisible, setsocialIconsVisible] = useState(false);

  const { sharePress, ShareModal } = useSharePress(title, url);

  return (
    <>
      <ShareModal />
      <OnboardingButton
        style={style}
        text={text}
        icon={Platform.OS === "ios" ? "share-outline" : "share-social-outline"}
        onPress={sharePress}
        {...props}
      />
    </>
  );
};

export default ShareEventButton;
